import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Card, Typography, Alert, Spin } from 'antd';
import { LoadingOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { PageLayout } from '../../components/PageLayout/PageLayout';

const { Title, Text } = Typography;

const VerifyPage = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const [responseData, setResponseData] = useState("");
    const [statusCode, setStatusCode] = useState(null);

    useEffect(() => {
        if (token) {
            axios.post(`https://api.banyano.app/api/v1/auth/verify?token=${token}`)
                .then(response => {
                    console.log('Verification response:', response.data);
                    console.log('Status code:', response.status);
                    setStatusCode(response.status);
                    setResponseData(response.data);
                })
                .catch(error => {
                    console.error('Verification error:', error);
                    console.log('Error status code:', error.response?.status);
                    setStatusCode(error.response?.status || 500);
                });
        }
    }, [token]);

    return (
        <PageLayout>
            <Card
                variant="outlined"
                style={{
                    textAlign: 'center',
                    border: '2px solid #7a7a7a',
                    
                }}
            >
                {statusCode === null && (
                    <div style={{ padding: '20px 0' }}>
                        <Spin
                            indicator={<LoadingOutlined style={{ fontSize: 48, color: '#6b7280' }} spin />}
                            size="large"
                        />
                        <Title
                            level={1}
                            style={{
                                
                                marginTop: 30,
                                marginBottom: 20
                            }}
                        >
                            Verifying...
                        </Title>
                        <Alert
                            type="info"
                            description="Please wait while we verify your account."
                            style={{
                                
                                
                                borderRadius: 12,
                                textAlign: 'left'
                            }}
                            showIcon={false}
                        />
                    </div>
                )}

                {statusCode === 200 && (
                    <>
                        <CheckCircleOutlined style={{ fontSize: 64, color: '#10b981', marginBottom: 20 }} />
                        <Title
                            level={1}
                            style={{
                                
                                marginBottom: 30
                            }}
                        >
                            Account Verified!
                        </Title>
                        <Alert
                            type="success"
                            description={
                                <span style={{ fontSize: 16, lineHeight: 1.8 }}>
                                    Great news! Your account <Text strong style={{ color: '#10b981' }}>'{responseData}'</Text> on
                                    BanYano is now fully activated. You can log in immediately and start BanYano-ing.
                                </span>
                            }
                            style={{
                                marginBottom: 25,
                                textAlign: 'left',
                                background: 'rgba(16, 185, 129, 0.1)',
                                borderLeft: '4px solid #10b981',
                                borderRadius: 12
                            }}
                            showIcon={false}
                        />
                        <Alert
                            type="info"
                            description="You can now close this page."
                            style={{
                                background: 'rgba(255, 255, 255, 0.05)',
                                
                                borderRadius: 8,
                                fontSize: '0.95rem'
                            }}
                            showIcon={false}
                        />
                    </>
                )}

                {statusCode !== 200 && statusCode !== null && (
                    <>
                        <CloseCircleOutlined style={{ fontSize: 64, color: '#ef4444', marginBottom: 20 }} />
                        <Title
                            level={1}
                            style={{
                                
                                marginBottom: 30
                            }}
                        >
                            Oops!
                        </Title>
                        <Alert
                            type="error"
                            description="Something went wrong. If this issue persists, please contact support."
                            style={{
                                marginBottom: 25,
                                textAlign: 'left',
                                background: 'rgba(239, 68, 68, 0.1)',
                                borderLeft: '4px solid #ef4444',
                                borderRadius: 12
                            }}
                            showIcon
                        />
                        <Alert
                            type="info"
                            description="You can now close this page."
                            style={{
                                background: 'rgba(255, 255, 255, 0.05)',
                                
                                borderRadius: 8,
                                fontSize: '0.95rem'
                            }}
                            showIcon={false}
                        />
                    </>
                )}
            </Card>
        </PageLayout>
    );
}

export default VerifyPage;